export class GatewayConfiguration{
  status: string = '';
  cssClass: string = '';
  lastUpload: number = -1;
}